import React, { Component } from 'react';
import Axios from 'axios';
import HeaderComponent from '../components/Header/HeaderComponent';
import { Jumbotron } from '../styles/Jumbotron';
import { WordPressAPI } from '../config';
import FeaturesComponent from '../components/Features/FeaturesComponent';
import QandAComponent from '../components/QandA/QandAComponent';
import FooterComponent from '../components/Footer/FooterComponent';
import VideoModalComponent from '../components/VideoModal/VideoModalComponent';
import IndexHeroComponent from '../components/IndexHero/IndexHeroComponent';
import CBBenefitsComponent from '../components/CBBenefits/CBBenefitsComponent';
import GetStartedModalComponent from '../components/GetStartedModal/GetStartedModalComponent';

class Index extends Component {
  state = {
    showVideoModal: false,
    showModal: false,
  };

  handleVideoModalOpen = () => {
    this.setState({ showVideoModal: true });
  };

  handleVideoModalClose = () => {
    this.setState({ showVideoModal: false });
  };

  handleModalOpen = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { acf } = this.props.data;
    const source = this.props.query && this.props.query.source;
    return (
      <React.Fragment>
        <Jumbotron>
          <div className="overlay">
            <HeaderComponent />
            <IndexHeroComponent
              handleModalOpen={this.handleModalOpen}
              handleVideoModalOpen={this.handleVideoModalOpen}
            />
          </div>
        </Jumbotron>
        <div className="gray-bg">
          <FeaturesComponent />
        </div>
        <CBBenefitsComponent handleModalOpen={this.handleModalOpen} />
        <div className="gray-bg">
          <QandAComponent title={acf.faq_title} data={acf.q_and_a} />
        </div>
        <FooterComponent />
        {this.state.showModal && (
          <GetStartedModalComponent unmountMe={this.handleModalClose} source={source} />
        )}
        {this.state.showVideoModal && (
          <VideoModalComponent
            unmountMe={this.handleVideoModalClose}
            videoId="za_dqf3P4y8"
          />
        )}
      </React.Fragment>
    );
  }
}

Index.getInitialProps = async () => {
  const { data } = await Axios.get(`${WordPressAPI.pages}/286`);

  return {
    data,
  };
};

export default Index;
